import { RightOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { FC, useCallback, useMemo } from 'react';
import styles from './NameColumn.module.scss';
import { NameIcon } from './components/NameIcon.component';

export interface NameColumnProps {
  id?: string | number;
  payload?: any;
  name?: string | number | null;
  onDetailsClick?: (id?: string | number, payload?: any) => void;
  itemType?: 'inventory' | 'task' | 'logbook' | 'document' | 'noType';
  filesTable?: boolean;
}

const NameColumn: FC<NameColumnProps> = ({ onDetailsClick, name, id, itemType, filesTable }) => {
  const nameMemo: string = useMemo(() => {
    if (name) {
      return name.toString();
    }

    return '(Undefined)';
  }, [name]);

  return (
    <div className={styles.nameColumnContainer}>
      <Typography.Paragraph ellipsis={{ rows: 1 }}>
        {itemType ? (
          <div>
            <NameIcon itemType={itemType} filesTable={filesTable} /> {nameMemo}
          </div>
        ) : (
          <div>{nameMemo}</div>
        )}
      </Typography.Paragraph>
      {!!onDetailsClick && (
        <Button type="link" className="btnDetails" onClick={() => onDetailsClick(id)}>
          Details
          <RightOutlined />
        </Button>
      )}
    </div>
  );
};

export { NameColumn };
